import React from "react";

import Typography from "../common/Typography/Typography";
import Icon, { Icons } from "../common/Icon/Icon";
import Card from "../common/Card/Card";
import Button from "../common/Buttons/Button/Button";
import CardActions from "../common/Card/CardActions";

import styles from "./Alert.module.css";

enum ContainerColor {
    error = "bg-plum-900",
    warning = "bg-mustard-900",
    success = "bg-mint-800",
    info = "bg-velvet-900",
}

const iconMap = {
    info: "info",
    warning: "warning",
    error: "warning",
    success: "success",
};

const colorMap = {
    info: styles.info,
    warning: styles.warning,
    error: styles.error,
    success: styles.success,
};

interface Props {
    title: string;
    description: string;
    type: "success" | "error" | "info" | "warning";

    onCancel?: () => void;
    cancelLabel?: string;

    onConfirm?: () => void;
    confirmLabel?: string;
}

const Alert = ({ type, title, description, onCancel, onConfirm, cancelLabel = "Cancel", confirmLabel = "Confirm" }: Props) => {
    const colorClass = colorMap[type];

    return (
        <Card className={`${styles.alert} ${colorClass}`}>
            <div className="flex items-start gap-1">
                <div className={`${styles.iconContainer} ${ContainerColor[type]}`}>
                    <Icon width="1.5rem" height="1.5rem" icon={iconMap[type] as Icons} className="flex-shrink-0" />
                </div>
                <div className="space-y-0.5 ">
                    <Typography as="h3" variant="emphasis">
                        {title}
                    </Typography>
                    <Typography as="p" variant="meta">
                        {description}
                    </Typography>
                </div>
            </div>
            <CardActions className="flex gap-1 justify-end">
                {typeof onCancel === "function" ? (
                    <Button variant="borderedMint" onClick={onCancel}>
                        {cancelLabel}
                    </Button>
                ) : null}
                <Button variant="secondary" onClick={onConfirm}>
                    {confirmLabel}
                </Button>
            </CardActions>
        </Card>
    );
};
export default Alert;
